"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _Comment = _interopRequireDefault(require("composer-lib/data/model/Comment"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-lib/lib/constants");

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var WEB_URL_REGEXP = /(\b(https?):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

var langKey = function langKey(key) {
  return "composer-lib.comment." + key;
};

var _default = (0, _createReactClass.default)({
  displayName: "Comment",
  propTypes: {
    comment: _propTypes.default.instanceOf(_Comment.default).isRequired,
    currentUserId: _propTypes.default.number.isRequired,
    deleteComment: _propTypes.default.func,
    deleteCommentId: _propTypes.default.number,
    deleteCommentStatus: _propTypes.default.string,
    deleteStatus: _propTypes.default.string,
    deletingConversation: _propTypes.default.bool,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  deleteComment: function deleteComment() {
    this.props.deleteComment(this.props.comment);
  },
  getMessageHTML: function getMessageHTML() {
    var messageWithParsedLinks = this.props.comment.message.replace(WEB_URL_REGEXP, function (match) {
      return "<a href=\"" + match + "\" target=\"_blank\">" + match + "</a>";
    });
    return {
      __html: messageWithParsedLinks
    };
  },
  renderDeleteButton: function renderDeleteButton() {
    var _this$props = this.props,
        comment = _this$props.comment,
        currentUserId = _this$props.currentUserId,
        deleteCommentStatus = _this$props.deleteCommentStatus,
        deletingConversation = _this$props.deletingConversation;

    if (comment.authorId !== currentUserId || deleteCommentStatus === _constants.RequestStatus.PENDING || deletingConversation) {
      return null;
    }

    return _react.default.createElement(_UIIcon.default, {
      className: "delete-button",
      name: "delete",
      onClick: this.deleteComment
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        comment = _this$props2.comment,
        deleteCommentId = _this$props2.deleteCommentId,
        deletingConversation = _this$props2.deletingConversation,
        deleteStatus = _this$props2.deleteStatus,
        users = _this$props2.users;

    var _parseUser = (0, _userHelpers.parseUser)(comment.authorId, users),
        email = _parseUser.email,
        firstName = _parseUser.firstName,
        lastName = _parseUser.lastName;

    var bodyClasses = (0, _classnames.default)('m-top-1', {
      'comment-body': true,
      deleting: deletingConversation || comment.id === deleteCommentId && deleteStatus === _constants.RequestStatus.PENDING
    });
    return _react.default.createElement("div", {
      className: "comment"
    }, _react.default.createElement("div", {
      className: "comment-header"
    }, _react.default.createElement(_UIAvatar.default, {
      className: "m-right-2",
      lookup: {
        type: 'hubSpotUserEmail',
        primaryIdentifier: email
      },
      size: "sm"
    }), _react.default.createElement("div", {
      className: "comment-author"
    }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "" + langKey('header'),
      options: {
        firstName: firstName,
        lastName: lastName
      }
    })), this.renderDeleteButton())), _react.default.createElement(_UIMediaBody.default, {
      className: bodyClasses
    }, _react.default.createElement("div", {
      dangerouslySetInnerHTML: this.getMessageHTML()
    })));
  }
});

exports.default = _default;
module.exports = exports.default;